import { Component } from '@angular/core';
import {Router, NavigationEnd} from "@angular/router";
declare var ga: Function;

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent {
//public static API_URL:string='https://dev.acadware.net/v6.53/';
//public static API_URL:string='https://stg.acadware.net/v6.46/';
//public static API_URL:string='https://api.acadware.net/v6.52/';
public static API_URL:string='https://dev.acadware.net/v6.52/';
// google Analytics s
constructor(public router: Router) 
  {    

    // this.router.events.subscribe(event => {
    //   if (event instanceof NavigationEnd) {       
    //     ga('set', 'page', event.urlAfterRedirects);
    //     ga('send', 'pageview');
        
    //   }
    // });
    
  }

  
}
